import React, { useState, useEffect, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { getStyles } from '../../../theme/styles';
import { Box, InputLabel, MenuItem, Select, FormControl, CircularProgress } from '@mui/material';
import customerService from '../../../services/CustomerService';
import { LocationDTO } from '@beable/roster-backend-client-v1';

interface LocationSelectProps {
  locationCode?: string;
  onChange: any;
  allOption?: boolean;
  disabled?: boolean;
  variant?: 'filled' | 'outlined';
}

export default function LocationSelector({ locationCode, onChange, allOption, disabled, variant }: LocationSelectProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [locations, setLocations] = useState<LocationDTO[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const memoOnChange = useCallback(onChange, []);
  const [selectedValue, setSelectedValue] = useState('');

  useEffect(() => {
    const fetchLocations = async () => {
        const data = await customerService.getLocations();
        if (data) setLocations(data);
        setIsLoading(false);
    };

    setIsLoading(true);
    fetchLocations();
  }, []);

  useEffect(() => {
    if (locations.length && locationCode) {
      setSelectedValue(locationCode)
      const selectedLocation: LocationDTO | undefined = locations.find(
        location => location.isoCode === locationCode
      );
      memoOnChange(selectedLocation);
    }
  }, [locations, locationCode, memoOnChange]);

  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
    const selectedLocation: LocationDTO | undefined = locations.find(location => location.isoCode === event.target.value);
    memoOnChange(selectedLocation);
  }

  return <>
  {isLoading && <Box sx={styles.loaderContainer}><CircularProgress disableShrink /></Box>}
  {!isLoading &&
    <FormControl sx={styles.pFormControl} variant={ variant || 'standard' }>
      <InputLabel htmlFor='locationCode'>{ !locations.length ? 'No Locations Found' : 'Select Location'}</InputLabel>
      <Select
        variant={ variant || 'standard' }
        value={selectedValue}
        onChange={handleChange}
        inputProps={{
          'name': 'locationCode',
          'id': 'locationCode',
          'data-testid': 'test-locationCode',
          'role': 'option'
        }}
        disabled={disabled}>
        { allOption && locations.length &&
          <MenuItem value='ALL' role='option'>
            All Locations
          </MenuItem>
        }
        {
          locations.length &&
          locations.map((location: LocationDTO) => (
            <MenuItem key={location.isoCode} value={location.isoCode} role='option'>
              {location.name}
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
   }
  </>;
}
